import Vue from "vue"
import Vuex from "vuex"
import router from './../router'



Vue.use(Vuex)


const store = new Vuex.Store({
    state: {
        userName:localStorage.getItem('pb_user_name'),
        tags:JSON.parse(localStorage.getItem('pb_tags')||'[]'),
        checkId:localStorage.getItem('pb_checkId'),
        menus:JSON.parse(localStorage.getItem('pb_menu')),//菜单
        slectedItem:""
    },
  
    mutations: {
      setMenu(state,menu){
        state.menus = menu;
        state.checkId = menu[0].children[0].id;
        state.tags = [menu[0].children[0]];
        state.slectedItem = menu[0].children[0].id;
        localStorage.setItem('pb_checkId',state.checkId);
        localStorage.setItem('pb_tags',JSON.stringify(state.tags))
      },
      setUserName(state,name){
          state.userName = name;
      },
      setTags(state,id){

        if(id){
          let isExist = state.tags.filter(item=>item.id===id).length;
          state.checkId = id;
          localStorage.setItem('pb_checkId',state.checkId);
          let selectMenu ;
          for(let i in state.menus){
              if(state.menus[i].children){
                  for(let j in state.menus[i].children){
                      if(state.menus[i].children[j].id === id){
                          selectMenu = state.menus[i].children[j];
                          // console.log(state.menus[i].children[j].path)
                      }
                  }
              }
          }
          if(!isExist){//不存在
              state.tags.push(selectMenu);
              localStorage.setItem('pb_tags',JSON.stringify(state.tags))
          }
        }
       
      },
      //关闭标签
      closeTags(state,id){
        let idx = state.tags.findIndex(item=>item.id===id);
        
        if(state.tags.length <= 1){
            return ;
        }
       
        if(state.checkId==state.tags[idx].id){
          state.tags.splice(idx,1);
          state.checkId = idx===0?state.tags[0].id:state.tags[idx-1].id;
          state.slectedItem = state.checkId;
          localStorage.setItem('pb_checkId',state.checkId);
          idx===0?router.push(state.tags[0].path):router.push(state.tags[idx-1].path)
        }else{
          state.tags.splice(idx,1);
        }
        localStorage.setItem('pb_tags',JSON.stringify(state.tags))
      },
      setSelected(state,id){
        state.slectedItem = id;
      },
      setCheckId(state,id){
        state.checkId = id;
        localStorage.setItem('pb_checkId',id);
      }
    },
    getters:{
     getTags(state){
         return state.tags.length===0?JSON.parse(localStorage.getItem('pb_tags')):state.tags;
     },
     getCheckId(state){
         return state.checkId?state.checkId:localStorage.getItem('pb_checkId');
     }
    },
    actions:{
  
    }
  })
  
  export default store;
  


// WEBPACK FOOTER //
// ./src/store/index.js